import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQueryClient as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
import { useCallback as r } from "react";
//#region src/properties/useEnsureListingDetail.ts
var i = () => {
	let i = t();
	return r((t) => i.ensureQueryData({
		queryKey: e.listing(t),
		queryFn: () => n.getListingDetail(t)
	}), [i]);
};
//#endregion
export { i as useEnsureListingDetail };
